import {
    Box,
    Button,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Text,
    InputGroup,
    InputRightElement,
    useToast,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { ReactComponent as Eye } from "../../svg/eye.svg";
import { ReactComponent as EyeSlash } from "../../svg/eyeSlash.svg";
import { useDispatch, useSelector } from "react-redux";
import { selectedMenu, resetEdit } from "../../redux/actions/actions";
import { useHistory } from "react-router-dom";
import {
    loadSettings, submitChangePassword
} from "../../redux/api_calls/apiCalls";

export default function Settings() {
    const [emailIdValue, setEmailIdValue] = useState("");
    const [currentPasswordValue, setCurrentPasswordValue] = useState("");
    const [newPasswordValue, setNewPasswordValue] = useState("");
    const [newConfirmPasswordValue, setNewConfirmPasswordValue] = useState("");
    const [currentPasswordError, setCurrentPasswordError] = useState(null);
    const [newPasswordError, setNewPasswordError] = useState(null);
    const [newConfirmPasswordError, setNewConfirmPasswordError] = useState(null);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { settingsData } = useSelector(state => state.settingsState)
    const formStatus = useSelector(state => state.formStatus)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch();
    const history = useHistory();
    const toast = useToast();





    function validateCurrentPassword() {
        let currentPassword = document.getElementById('current_password').value;
        if (!currentPassword.length) {
            setCurrentPasswordError("Current Password is required")
            return true
        }
        else {
            setCurrentPasswordError(null);
            setCurrentPasswordValue(currentPassword);
            return false
        }
    }

    function validateNewPassword() {
        let newPassword = document.getElementById('new_password').value;
        if (!newPassword.length) {
            setNewPasswordError("New Password is required")
            return true
        }
        else {
            setNewPasswordError(null);
            setNewPasswordValue(newPassword);
            return false
        }
    }

    function validateNewConfirmPassword() {
        let newConfirmPassword = document.getElementById('confirm_password').value;
        if (!newConfirmPassword.length) {
            setNewConfirmPasswordError("New Confirm Password is required")
            return true
        } else if (newConfirmPassword !== document.getElementById('new_password').value) {
            setNewConfirmPasswordError("New Password and Confirmation Password are not same")
            return true
        }
        else {
            setNewConfirmPasswordError(null);
            setNewConfirmPasswordValue(newConfirmPassword);
            return false
        }
    }


    const validatePasswordFields = () => {
        return validateCurrentPassword() || validateNewPassword() || validateNewConfirmPassword();
    }


    // const changePasswordSwitchHandler = () => {
    //     setIsMyProfileActive(false);
    // };


    const showOnload_image = (image) => {};


    const changePasswordHandler = () => {
        if (validatePasswordFields()) {
            return
        } else {
            let formData = {
                email: emailIdValue,
                current_password: document.getElementById('current_password').value,
                password: document.getElementById('new_password').value,
                password_confirmation: document.getElementById('confirm_password').value
            }
            dispatch(submitChangePassword(formData));
        }
    };

    const resetForm = () => {
        // setCourseImage(null);
        // setCourseImageUrl(null)
        setCurrentPasswordValue("");
        setNewPasswordValue("");
        setNewConfirmPasswordValue("");
    }

    const cancelHandler = () => {
        dispatch(resetEdit());
        history.push("/dashboard");
    };

    const handleCurrentPasswordClick = () => setShowCurrentPassword(!showCurrentPassword);

    const handleNewPasswordClick = () => setShowNewPassword(!showNewPassword);

    const handleConfirmPasswordClick = () => setShowConfirmPassword(!showConfirmPassword);

    useEffect(() => {
        dispatch(selectedMenu(8))
        let formData = {
            email: "admin1@gmail.com",
            token: "WpMrIjpkL9pUZTXG4Jh3I9VTMO7Lsc5r"
        }
        console.log(formData)
        dispatch(loadSettings(formData));
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setEmailIdValue(settingsData.email);
            // setCourseImage("https://pixy.org/src/19/193722.jpg");
            showOnload_image(settingsData.profile);
        }, 0);
        console.log("settingsData", settingsData);
    }, [settingsData]);

    useEffect(() => {
        if (formStatus.success) {
            toast({
                title: "Password Changed Successfully!",
                description: "Password Changed",
                status: "success",
                duration: 1000,
                isClosable: true,
            })
            resetForm()
        }
        else if (formStatus.error) {
            toast({
                title: "Something went wrong!",
                description: "Error!",
                status: "error",
                duration: 1000,
                isClosable: true,
            })
        }
        // eslint-disable-next-line
    }, [formStatus.success, formStatus.error]);

    useEffect(() => {
        if (formStatus.updateSuccess) {
            toast({
                title: "Update Profile Successfully!",
                description: "Update Profile",
                status: "success",
                duration: 1000,
                isClosable: true,
            })
            resetForm()
        }
        else if (formStatus.updateError) {
            toast({
                title: "Something went wrong!",
                description: "Error!",
                status: "error",
                duration: 1000,
                isClosable: true,
            })
        }
        // eslint-disable-next-line
    }, [formStatus.updateSuccess, formStatus.updateError]);

    return (
        <Box
            flexGrow="1"
            d="flex"
            justifyContent="flex-start"
            alignItems="center"
            flexDirection="column"
            minH="90vh"
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box
                width={["95%", "95%", "90%", "85%"]}
                justifyContent={["center", "center", "flex-start", "flex-start"]}
                alignItems={["center", "center", "flex-start", "flex-start"]}
                d="flex"
                mb="2rem"
                flexDirection="column"


            >
                <Text
                    fontSize={["20px", "25px", "30px", "40px"]}
                    d={["none", "none", "none", "flex"]}
                    fontWeight="900"
                    style={{ fontFamily: "Mulish, sans-serif" }}
                    mb="2rem"
                >
                   Change password
                </Text>
                <Box
                    width={["100%", "100%", "90%", "85%"]}
                    bgColor='white'  
                    borderRadius='20px' 
                    py='0.2rem'
                    pl='1rem'
                    mt='1rem' 
                    pr='1rem'
                    mb='5rem'  
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                >
                <Box
                    width={["100%", "100%", "90%", "85%"]}
                    d="flex"
                    flexDir={["column", "column", "row", "row"]}
                    justifyContent={["center", "center", "flex-start", "flex-start"]}
                    mt="1.5rem"
                   
                >
                    <span id="change_password" />
                </Box>
                {<>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        justifyContent="space-between"
                        mb="1rem"

                    >
                        <Box width={window.outerWidth > 768 ? "45%" : "100%"}>
                            <FormControl isInvalid={currentPasswordError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Current Password
                                </FormLabel>
                                <InputGroup size="md">
                                    <Input
                                        pr="4.5rem"
                                        type={showCurrentPassword ? "text" : "password"}
                                        color="#666666"
                                        id="current_password"
                                        borderRadius="lg"
                                        bgColor="white"
                                        value={currentPasswordValue}
                                        onChange={(e) => {
                                            setCurrentPasswordError(null)
                                            setCurrentPasswordValue(e.target.value);
                                        }}
                                        fontSize={["9px", "11px", "13px", "16px"]}
                                    />
                                    <InputRightElement width="4.5rem">
                                        <Button style={{ backgroundColor: "transparent", padding: "0" }} size="sm" onClick={handleCurrentPasswordClick}>
                                            {!showCurrentPassword ? (<EyeSlash style={{ width: "1.5rem", height: "1.2rem" }} />) : (<Eye style={{ width: "1.5rem", height: "1.2rem" }} />)}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                <FormErrorMessage fontSize="sm">
                                    {currentPasswordError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        justifyContent="space-between"
                        mb="1rem"
                    >
                        <Box width={window.outerWidth > 768 ? "45%" : "100%"}>
                            <FormControl isInvalid={newPasswordError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    New Password
                                </FormLabel>
                                <InputGroup size="md">
                                    <Input
                                        pr="4.5rem"
                                        type={showNewPassword ? "text" : "password"}
                                        color="#666666"
                                        id="new_password"
                                        borderRadius="lg"
                                        bgColor="white"
                                        value={newPasswordValue}
                                        onChange={(e) => {
                                            setNewPasswordError(null)
                                            setNewPasswordValue(e.target.value);
                                        }}
                                        fontSize={["9px", "11px", "13px", "16px"]}
                                    />
                                    <InputRightElement width="4.5rem">
                                        <Button style={{ backgroundColor: "transparent" }} size="sm" onClick={handleNewPasswordClick}>
                                            {!showNewPassword ? (<EyeSlash style={{ width: "1.5rem", height: "1.2rem" }} />) : (<Eye style={{ width: "1.5rem", height: "1.2rem" }} />)}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                <FormErrorMessage fontSize="sm">
                                    {newPasswordError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        justifyContent="space-between"
                    >
                        <Box width={window.outerWidth > 768 ? "45%" : "100%"}>
                            <FormControl isInvalid={newConfirmPasswordError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Confirm Password
                                </FormLabel>
                                <InputGroup size="md">
                                    <Input
                                        pr="4.5rem"
                                        type={showConfirmPassword ? "text" : "password"}
                                        color="#666666"
                                        id="confirm_password"
                                        borderRadius="lg"
                                        bgColor="white"
                                        value={newConfirmPasswordValue}
                                        onChange={(e) => {
                                            setNewConfirmPasswordError(null)
                                            setNewConfirmPasswordValue(e.target.value);
                                        }}
                                        fontSize={["9px", "11px", "13px", "16px"]}
                                    />
                                    <InputRightElement width="4.5rem">
                                        <Button style={{ backgroundColor: "transparent" }} size="sm" onClick={handleConfirmPasswordClick}>
                                            {!showConfirmPassword ? (<EyeSlash style={{ width: "1.5rem", height: "1.2rem" }} />) : (<Eye style={{ width: "1.5rem", height: "1.2rem" }} />)}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                <FormErrorMessage fontSize="sm">
                                    {newConfirmPasswordError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        flexDir={["column", "column", "row", "row"]}
                        justifyContent={["center", "center", "flex-start", "flex-start"]}
                        mt="2rem"
                        mb="2rem"
                    >
                        <Button
                            bgColor="#A0A4D9"
                            color="white"
                            borderRadius="lg"
                            p={["6px 15px", "8px 20px", "12px 30px"]}
                            _hover={{ bg: "#9093c2" }}
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="800"
                            fontSize={["13px", "14px", "16px"]}
                            mr={["0", "0", "20px", "20px"]}
                            mb={["20px", "20px", "0", "0"]}
                            onClick={changePasswordHandler}
                        >
                            Change Password
                        </Button>
                        <Button
                            bgColor="white"
                            color="#999999"
                            borderRadius="lg"
                            border="1px solid rgba(0, 0, 0, 0.2)"
                            p={["6px 15px", "8px 20px", "12px 30px"]}
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="800"
                            fontSize={["13px", "14px", "16px"]}
                            onClick={cancelHandler}
                        >
                            Cancel
                        </Button>
                    </Box>
                </>}
                </Box>
            </Box>
        </Box >
    );
}
